Auth = require 'app/scripts/db/auth'
ModelLoader = require 'app/scripts/db/model-loader'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
_ = require 'underscore'
templates = require 'app/scripts/views/internal/templates'

module.exports = class MembersVotedView extends View
  viewTitleKey: 'voters'

  events:
    'click .js-more-members-voted': 'showAll'
    'click .js-vote': 'vote'
    'click .js-unvote': 'unvote'

  initialize: ->
    ModelLoader.loadCardVoters(@model.id).done()
    @listenTo @model.memberVotedList, 'add remove reset', @frameDebounce @render

  showAll: ->
    @render(true)

  render: (all) ->
    memberVotedList = @model.memberVotedList

    data =
      members: ( member.toJSON() for member in memberVotedList.models )

    # When render is called from the listenTo it gets passed the memberVotedList so we want to specify that it has to not equal true
    if all != true
      data.members = data.members.slice(0, 48)
      # we only load this if there are voters so voters = 0 means we're still
      # loading them
      data.loading = memberVotedList.length == 0
      data.fewMembers = memberVotedList.length < 14
      data.moreMembers = memberVotedList.length > 48
      data.lengthDiff = memberVotedList.length - 48
      data.canVote = @model.getBoard().canVote(Auth.me())
      data.voted = _.include(@model.get('idMembersVoted'), Auth.myId())

    @$el.html(
      templates.fill(
        'members_voted',
        data,
        {},
        { member: templates.member }
      )
    )

    @

  vote: (e) ->
    Util.preventDefault(e)
    @model.vote(true)
    false

  unvote: (e) ->
    Util.preventDefault(e)
    @model.vote(false)
    if @model.get('idMembersVoted').length == 0
      PopOver.hide()
    false
